const dynamicPackage = {
  detailedPlan: "Plan détaillé", // translated
  minimum: "Le minimum", // translated
  maximum: "Maximum", // translated
};

export default dynamicPackage;
